import Vue from 'vue'
import Router from 'vue-router'
import Found from '@/views/Found'
import Send from '@/views/Send'
import Initial from '@/views/Initial'
import NotFound from '@/views/error'
import Login from '@/views/Login'
import Register from '@/views/Register'
import ChangeReg from '@/views/ChangeReg'
import Cookies from 'js-cookie'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: '创建工资条',
      component: Found,
      icon:'fa fa-edit',
      meta: {
        index:0, //判断当前页面展示的是哪个页面，从而让对应的侧边栏添加选中样式
        keepAlive: true //在app.vue中可设置v-if="!$route.meta.keepAlive"判断是否需要引入公共组件
      }
    },
    {
      path: '/Send',
      name: '查看工资条',
      component: Send,
      icon:'fa fa-eye',
      meta: {
        index:1,
        keepAlive: true
      }
    },
    {
      path: '/Initial',
      name: '初始员工密码',
      component: Initial,
      icon:'',
      meta: {
          index:2,
          keepAlive: true
      }
    },
    {
        path: '/error',
        name: 'notFound',
        component: NotFound,
        meta: {
            index:3,
            keepAlive: false
        }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
          index:4,
          keepAlive: false
      }
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register,
      meta: {
          index:5,
          keepAlive: false
      }
    },
    {
      path: '/ChangeReg',
      name: 'ChangeReg',
      component: ChangeReg,
      meta: {
          index:6,
          keepAlive: false
      }
    }
  ],
})

router.beforeEach((to, from, next) => {
    let url = window.location.href.split('makerId=')[1];
    if(url){
        // 从诚云进来
        let getToken = url.split('#')[0];
        Cookies.set('token',getToken);
        next()
    }else{
        // 从第三方进来
        // 存在时间为会话生命周期，页面关闭即失效。登录界面登录成功之后，会把用户信息保存在会话
        let userName = sessionStorage.getItem('user')
        if (to.path === '/Login') {
            // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
            if (userName) {
                next({ path: '/' })
            } else {
                next()
            }
        }else{
            if (!userName && to.path !== '/Register') {
                // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
                next({ path: '/Login' })
            } else {
                next()
            }
        }
    }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js